<ng-template #deviceDetail let-unitInfo> <cue-unit-detail [unitInfo]="unitInfo" [showTitle]="false" /></ng-template>

<div class="w-full h-full flex flex-col justify-start items-start gap-3">
  @if (unitInfos()?.length === 1) {
    <ng-container *ngTemplateOutlet="deviceDetail; context: { $implicit: unitInfos()[0] }" />
  } @else {
    @for (unitInfo of unitInfos(); track unitInfo.serialNumber) {
      <kendo-expansionpanel
        class="show-panel w-full"
        expandIcon="k-icon k-font-icon k-i-plus"
        collapseIcon="fa fa-minus"
        [title]="unitInfo.magicName"
      >
        <ng-container *ngTemplateOutlet="deviceDetail; context: { $implicit: unitInfo }" />
      </kendo-expansionpanel>
    }
  }
</div>
